import React from 'react'

import { InstantQuoteQuestions } from '@flows-ui/components/InstantQuoteQuestions'
import type {
  AnyStepContentElement,
  InjectedStepContentRendererProps,
} from '@flows/core/types/stepContentTypes'

const PRODUCT_KEY = 'liability_v1_getsafe_de' as const

export const LiabilityInstantQuoteQuestions = (
  props: InjectedStepContentRendererProps<AnyStepContentElement>
) => (
  <InstantQuoteQuestions
    {...props}
    productKey={PRODUCT_KEY}
    damagesTitleKey="sharedFlows_common:customComponents.liabilityInstantQuoteQuestions.damages.title"
  />
)
